(function ($) {
	"use strict";
	$(function () {
		// 1. --- Owl Carousel (Sécurisé) ---
		if ($(".clients-slider").length > 0) {
			$(".clients-slider").owlCarousel({
				loop: true,
				margin: 50,
				nav: false,
				dots: false,
				autoplay: true,
				autoplayTimeout: 3000,
				autoplaySpeed: 3000,
				fluidSpeed: true,
				autoplayHoverPause: false,
				slideTransition: "linear",
				responsive: {
					0: { items: 2 },
					600: { items: 4 },
					1000: { items: 6 },
				},
			});
		}

		// 2. --- Counter Animation (Sécurisé) ---
		const counters = document.querySelectorAll(".stat-number[data-target]");
		if (counters.length > 0) {
			const counterObserver = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const counter = entry.target;
							const target = parseInt(counter.getAttribute("data-target"));
							const duration = 2000;
							const startTime = performance.now();
							const updateCounter = (currentTime) => {
								const elapsedTime = currentTime - startTime;
								const progress = Math.min(elapsedTime / duration, 1);
								const currentValue = Math.floor(progress * target);
								counter.textContent = currentValue;
								if (progress < 1) {
									requestAnimationFrame(updateCounter);
								} else {
									counter.textContent = target;
								}
							};
							requestAnimationFrame(updateCounter);
							observer.unobserve(counter);
						}
					});
				},
				{ threshold: 0.5 },
			);
			counters.forEach((counter) => counterObserver.observe(counter));
		}

		// 3. --- Initialisation Isotope (Sécurisé) ---
		if ($(".grid-portfolio").length > 0) {
			var $grid = $(".grid-portfolio").isotope({
				itemSelector: ".portfolio-item",
				layoutMode: "fitRows",
				stagger: 30,
			});

			$(".portfolio-filters").on("click", "button", function () {
				var filterValue = $(this).attr("data-filter");
				$grid.isotope({ filter: filterValue });
				$(".btn-filter").removeClass("active");
				$(this).addClass("active");
			});
		}

		// 4. --- Preloader & AOS Refresh (Unique et Propre) ---
		const loader = document.getElementById("page-loader");

		// On initialise AOS mais on attend le signal pour l'activer
		AOS.init({
			// Désactive AOS si la largeur de l'écran est inférieure à 992px (Tablettes + Mobiles)
			disable: function () {
				var maxWidth = 992;
				return window.innerWidth < maxWidth;
			},
			startEvent: "DOMContentLoaded",
			// Paramètres d'animation optimisés :
			offset: 100,
			delay: 0,
			duration: 900,
			easing: "ease-in-out",
			once: true,
			mirror: false,
			anchorPlacement: "top-bottom",
			// Performance :
			debounceDelay: 50,
			throttleDelay: 99,
		});

		if (loader) {
			window.addEventListener("load", () => {
				setTimeout(() => {
					loader.classList.add("loaded");
					setTimeout(() => {
						loader.style.display = "none";
						AOS.refresh();
					}, 800);
				}, 1000);
			});
		} else {
			AOS.refresh();
		}
	});
	//header scroll
	window.addEventListener("scroll", function () {
		const navbar = document.querySelector(".custom-navbar");
		if (window.scrollY > 50) {
			navbar.classList.add("scrolled");
		} else {
			navbar.classList.remove("scrolled");
		}
	});

	// Initialisation de la lightbox
	const lightbox = GLightbox({
		selector: ".glightbox",
	});

	// Back to the top
	const backToTopBtn = document.getElementById("backToTop");

	window.addEventListener("scroll", function () {
		if (window.pageYOffset > 300) {
			backToTopBtn.classList.add("show");
		} else {
			backToTopBtn.classList.remove("show");
		}
	});

	backToTopBtn.addEventListener("click", function () {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
})(jQuery);
